import { render, staticRenderFns } from "./EmpresasForm.vue?vue&type=template&id=04f83050&scoped=true&"
import script from "./EmpresasForm.vue?vue&type=script&lang=js&"
export * from "./EmpresasForm.vue?vue&type=script&lang=js&"
import style0 from "./EmpresasForm.vue?vue&type=style&index=0&id=04f83050&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f83050",
  null
  
)

export default component.exports